import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { MenuItemButtonInput } from '@trackback/widgets';
import { ACTION_DISPATCHER } from '@app/models/action-dispatcher.model';
import { MatMenuItem } from '@angular/material/menu';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';
import parsed from '@app/utils/parsed';

@Component({
  selector: 'tb-menu-item-button',
  imports: [DynamicWidgetDirective, MatMenuItem],
  template: `
    <button
      mat-menu-item
      [class]="parsedStyleClasses()"
      [disabled]="parsedDisabled()"
      (click)="
        actionDispatcher.dispatch(input().onClick, context()).toPromise()
      "
    >
      @for (child of input().children; track $index) {
        <ng-container [dynamicWidget]="child" [context]="context()" />
      }
    </button>
  `,
  styles: `
    tb-menu-item-button {
      display: contents;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class MenuItemButtonComponent extends WidgetInputBaseComponent<MenuItemButtonInput> {
  parsedStyleClasses = parsed(this.inputProp('styleClasses'), this.context);
  parsedDisabled = parsed(this.inputProp('disabled'), this.context);

  actionDispatcher = inject(ACTION_DISPATCHER);
}
